module.exports = function() {
  return new Worker(__webpack_public_path__ + "1b92fe279dd6c77932ac.worker.js");
};